import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Alert,
  CircularProgress,
} from "@mui/material";
import Link from "@mui/material/Link";
import { useContext, useEffect, useState } from "react";
import { SaveButton } from "../../../components/SaveButton";
import { useStyles } from "./styles";
import facebook from "../../../assets/icons/facebook.png";
import instagram from "../../../assets/icons/instagram.png";
import InstagramIconGray from "@mui/icons-material/Instagram";
import FacebookIconGray from "@mui/icons-material/FacebookOutlined";
import { useNavigate, useLocation, createSearchParams } from "react-router-dom";
import { useMutation } from "react-query";
import {
  createFbUser,
  updateFbUser,
} from "../../../services/connectionSocialNetworks";
import { useToast } from "../../../hooks/useToast";
import {
  PageFacebook,
  ResponseUserFacebook,
  SocialNetworksProps,
} from "../../../types/connectionSocialNetworks";
import {
  SocialNetworkContext,
  SocialNetworkContextData,
} from "../../../contexts/SocialNetworksContext";

export function SocialNetworks({ advance }: SocialNetworksProps) {
  const styles = useStyles();
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    socialNetwork,
    updateUserMutationNonCapturedError,
    isConnected,
    setSocialNetwork,
    setUpdateUserMutationNonCapturedError,
    setIsConnected,
  } = useContext(SocialNetworkContext) as SocialNetworkContextData;

  const [userId, setUserId] = useState("");
  const [pages, setPages] = useState([] as PageFacebook[]);
  const [isLoadingCreateUser, setIsLoadingCreateUser] = useState(false);
  const [isLoadingUpdateUser, setIsLoadingUpdateUser] = useState(false);
  const [modalAddPages, setModalAddPages] = useState(true);

  useEffect(() => {
    const params = {
      addAccount: "SocialNetworks",
    };
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams(params)}`,
    };

    navigate(options, { replace: true });
  }, [location.pathname, navigate]);

  const createUserMutation = useMutation(createFbUser, {
    onSuccess: async (response) => {
      return response;
    },
    onError: (err) => {
      setIsLoadingUpdateUser(false);
      console.log("create store", err);
    },
  });

  const updateUserMutation = useMutation(updateFbUser, {
    onSuccess: async (result) => {
      ("");

      /**
       * If has a value with 'error' in any part of the string "result?.name"
       * means there is an error
       */
      const resultName = result?.name;

      if (resultName && resultName.toLowerCase().includes("error")) {
        setUpdateUserMutationNonCapturedError(true);

        return;
      }

      setIsLoadingUpdateUser(false);
      setIsConnected(true);
      toast.show("Sua conta do facebook foi conectada com sucesso!.", {
        severity: "success",
      });
    },
    onError: (err) => {
      setIsLoadingUpdateUser(false);
    },
  });

  const handleValidationInstagramBusiness = (pageInfo: PageFacebook) =>
    pageInfo && pageInfo.isInstagramBusiness === 0;

  const isInstagramBusiness = (pageInfo: PageFacebook) => {
    return handleValidationInstagramBusiness(pageInfo) ? (
      <div className={styles.containerAlertValidationInstagramBusiness}>
        <Typography fontSize={13}>
          {" "}
          Este perfil de Instagram não é do tipo comercial{" "}
        </Typography>
      </div>
    ) : null;
  };

  const handleChangeCheckBox = (index: number) => {
    const tmp = [...pages];

    tmp[index] = { ...tmp[index], checked: !tmp[index].checked };

    setPages(() => tmp);
  };

  const handleCreateUser = () => {
    setIsLoadingCreateUser(true);
    FB.login(
      function (resLogin) {
        FB.getLoginStatus(async (resStatus) => {
          if (resStatus.status === "connected") {
            FB.api(
              "/me",
              { fields: "name, email, picture" },
              async (responseMe: ResponseUserFacebook) => {
                try {
                  if (resStatus?.authResponse) {
                    await createUserMutation.mutateAsync({
                      fb_user_id: resStatus.authResponse.userID,
                      name: responseMe.name,
                      email: responseMe.email,
                      picture_url: responseMe.picture.data.url,
                      access_token: resStatus.authResponse.accessToken,
                      expires_in: resStatus.authResponse.expiresIn,
                      data_access_expiration_time:
                        resStatus.authResponse.data_access_expiration_time,
                      is_connected: resStatus.status === "connected",
                    });

                    setSocialNetwork({
                      ...responseMe,
                      picture_url: responseMe.picture.data.url,
                    });
                  }

                  setUserId(resStatus.authResponse.userID);
                } catch (err: any) {
                  setIsLoadingCreateUser(false);
                } finally {
                  setIsLoadingCreateUser(false);
                }
              }
            );
          }
        });
      },
      {
        scope:
          "public_profile," +
          "email," +
          "pages_show_list," +
          "pages_manage_posts," +
          "pages_read_engagement," +
          "instagram_basic," +
          "ads_management," +
          "instagram_content_publish," +
          "read_insights," +
          "pages_read_user_content," +
          "instagram_manage_insights",
      }
    );

    setIsLoadingCreateUser(false);
  };

  const handleUpdateUser = async () => {
    setIsLoadingUpdateUser(true);

    pages.forEach(async (page) => {
      if (page.checked) {
        try {
          if (page && userId) {
            await updateUserMutation.mutateAsync({
              fb_user_id: userId,
              page_id: page.page_id,
              active: 1,
            });
          } else {
            alert("Nenhum usuário ou página selecionado(a).");
          }
        } catch (err: any) {
          console.log("catch - update FB", err.message);
        } finally {
          setModalAddPages(false);
          setIsLoadingUpdateUser(false);
        }
      }
    });
  };

  useEffect(() => {
    if (createUserMutation.status === "success") {
      const createUserResponse = createUserMutation.data;

      if (createUserResponse?.content?.pages) {
        const addCheckedAttribute = createUserResponse?.content?.pages.map(
          (page: PageFacebook) => ({ ...page, checked: false })
        );

        setPages(addCheckedAttribute);
        setIsLoadingUpdateUser(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const icons = () => {
    return (
      <Box sx={{ display: "flex", gap: "0.5rem" }}>
        {isLoadingCreateUser || isLoadingUpdateUser ? (
          <>
            <FacebookIconGray sx={{ color: "gray" }} />
            <InstagramIconGray sx={{ color: "gray" }} />
          </>
        ) : (
          <>
            <img src={facebook} alt="Facebook Logo" />
            <img src={instagram} alt="instagram Logo" />
          </>
        )}
      </Box>
    );
  };

  return (
    <Grid container>
      <Grid xs={12} item className={styles.boxTitle}>
        <Grid>
          <Typography className={styles.titulo}>
            Conectar redes sociais
          </Typography>
          <Typography className={styles.subtitulo}>
            Vincule as redes sociais do seu negócio onde serão enviadas suas
            propagandas e ofertas.
          </Typography>
          <Link
            href={"https://www.youtube.com/watch?v=zYz4kF_qTtc"}
            target={"_blank"}
            underline="none"
          >
            <Button
              variant="contained"
              sx={{
                color: "#ffffff",
                backgroundColor: "#0C20B5",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textAlign: "left",
                display: "block",
                marginTop: "22px",
              }}
            >
              Como configurar esta página?
            </Button>
          </Link>
        </Grid>
      </Grid>
      <Divider className={styles.firstDivider} />
      <Grid xs={12} item>
        <Button
          disabled={isLoadingCreateUser || isLoadingUpdateUser}
          color={"inherit"}
          className={styles.buttonConect}
          startIcon={icons()}
          onClick={handleCreateUser}
        >
          {isLoadingCreateUser || isLoadingUpdateUser ? (
            <CircularProgress size={24} color={"secondary"} />
          ) : (
            "Conectar redes sociais"
          )}
        </Button>

        {isConnected && !updateUserMutationNonCapturedError && (
          <Alert
            severity="success"
            className={`${styles.alertStatusConnection} ${styles.statusConnectionSuccess}`}
          >
            <Typography>
              {" "}
              Conta conectada: {socialNetwork?.name} {""}
            </Typography>
          </Alert>
        )}

        {(updateUserMutation.isError || updateUserMutationNonCapturedError) && (
          <Alert
            severity="warning"
            className={`${styles.alertStatusConnection} ${styles.statusConnectionError}`}
          >
            Erro ao conectar conta. Você pode fazer isso depois. 🤗
          </Alert>
        )}
      </Grid>
      <Divider className={styles.firstDivider} />
      <Grid item xs={12} className={styles.boxButtons}>
        <Button
          className={styles.buttonPular}
          onClick={() => {
            advance(3);
          }}
        >
          Pular etapa
        </Button>
        <SaveButton
          titulo="Continuar"
          isSubmitting={isLoadingCreateUser || isLoadingUpdateUser}
          size="large"
          onSave={() => {
            advance(3);
          }}
        />
      </Grid>

      {pages?.length > 0 && modalAddPages ? (
        <>
          <Dialog maxWidth="sm" fullWidth open={true} onClose={() => {}}>
            <DialogTitle>Adicionar perfil</DialogTitle>
            <Divider />
            <DialogContent>
              <div>
                {pages && pages?.length > 0 && (
                  <div style={{ paddingBottom: 24 }}>
                    <FormControl component="fieldset">
                      <Typography
                        component="legend"
                        style={{ marginBottom: 20 }}
                      >
                        Selecione a página para o perfil:
                      </Typography>
                      <FormGroup>
                        <ul
                          style={{
                            listStyleType: "none",
                            margin: 0,
                            padding: 0,
                          }}
                        >
                          {pages.map((page, index) => (
                            <li key={`socialNetwork-page-${index}`}>
                              <FormControlLabel
                                disabled={handleValidationInstagramBusiness(
                                  page
                                )}
                                control={
                                  <Checkbox
                                    disabled={handleValidationInstagramBusiness(
                                      page
                                    )}
                                    key={Math.random()}
                                    checked={page.checked}
                                    onChange={(event) =>
                                      handleChangeCheckBox(index)
                                    }
                                    inputProps={{ "aria-label": "controlled" }}
                                    name={page.page_name}
                                  />
                                }
                                label={
                                  page.page_name +
                                  (page.instagram_username
                                    ? " (Instagram: " +
                                      page.instagram_username +
                                      ")"
                                    : "")
                                }
                              />

                              {isInstagramBusiness(page)}
                            </li>
                          ))}
                        </ul>
                      </FormGroup>
                    </FormControl>

                    {pages.some((currentPage) =>
                      handleValidationInstagramBusiness(currentPage)
                    ) ? (
                      <Alert
                        severity="info"
                        style={{ color: "#004EA9", marginTop: "24px" }}
                      >
                        Sua conta do Instagram não é do tipo{" "}
                        <strong>empresarial</strong>. Para fazer a distribuição
                        no Instagram, você precisa ter uma conta do tipo{" "}
                        <strong>empresarial</strong>.
                        <a
                          href="https://www.youtube.com/watch?v=mPwXxoAkfsY"
                          target={"_blank"}
                          rel="noreferrer"
                        >
                          {" "}
                          Clique aqui
                        </a>{" "}
                        para descobrir como.
                        <br />
                        Após isso, <strong>reconecte</strong> a sua conta do
                        instagram a sua pagina do facebook e logo em seguida
                        refaça a sua distribuição, em caso de dúvidas acione o
                        suporte da Datasales.
                      </Alert>
                    ) : null}
                  </div>
                )}

                {pages && pages?.length === 0 && (
                  <div style={{ marginBottom: 40, marginTop: 30 }}>
                    Nenhuma página encontrada
                  </div>
                )}

                <Box display={"flex"} justifyContent={"flex-end"}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpdateUser}
                    disabled={isLoadingCreateUser || isLoadingUpdateUser}
                  >
                    {isLoadingCreateUser || isLoadingUpdateUser ? (
                      <CircularProgress size={24} color={"secondary"} />
                    ) : (
                      "Salvar página(s)"
                    )}
                  </Button>
                </Box>
              </div>
            </DialogContent>
          </Dialog>
        </>
      ) : null}
    </Grid>
  );
}
